import * as ACTIONS from "./../actions/actionConstants";

export const initialState = {
  auth: null,
  currentUser: {
    profile: {
      notes: null,
      email: null,
      name: null,
      phone: null,
      position: null
    },
    clientKey: null,
    isAuthenticated: false,
    users: {},
    uUID: null,
    role: "default",
    userDataFetched: false
    //Client data
  },
  errors: ""
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.IS_AUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: action.payload
      };
    }
    case ACTIONS.RESET_USER: {
      return {
        ...state,
        currentUser: {
          ...initialState.currentUser
        }
      };
    }
    case ACTIONS.SET_AUTH: {
      return {
        ...state,
        auth: action.payload
      };
    }
    case ACTIONS.UPDATE_USER: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...action.payload
        }
      };
    }
    case ACTIONS.UPDATE_CLIENT: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...action.payload
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js